import { Filters } from "../types/filters";

interface FilterListItem {
  type: string;
  name: string;
  values: (string | number)[] | undefined
}

export const getFilterList = (appliedFilters: Filters, include_all = false) => {
  const {
    category,
    model,
    price,
    year,
    mileage,
    trimline,
    transmission,
    color_exterior,
    color_interior,
  } = appliedFilters;

  const filterList: FilterListItem[] = [];

  if (include_all) {
    if (category?.length) {
      filterList.push({
        type: "multi_value",
        name: "VC",
        values: category
      })
    }

    if (model?.length) {
      filterList.push({
        type: "multi_value",
        name: "CG",
        values: model
      })
    }
  }

  if (year) {
    filterList.push({
      type: "range",
      name: "MY",
      values: year
    })
  }

  if (price) {
    filterList.push({
      type: "single_value",
      name: "PRT",
      values: [price]
    })
  }

  if (mileage) {
    filterList.push({
      type: "single_value",
      name: "KRT",
      values: [mileage]
    })
  }

  if (trimline?.length) {
    filterList.push({
      type: "multi_value",
      name: "TR",
      values: trimline
    })
  }

  if (transmission?.length) {
    filterList.push({
      type: "multi_value",
      name: "GT",
      values: transmission
    })
  }

  if (color_exterior?.length) {
    filterList.push({
      type: "multi_value",
      name: "EC",
      values: color_exterior && color_exterior.length > 0 ? color_exterior : []
    })
  }

  if (color_interior?.length) {
    filterList.push({
      type: "multi_value",
      name: "IC",
      values: color_interior && color_interior.length > 0 ? color_interior : []
    })
  }

  return filterList;
};
